import { cn } from "@/utils/utils";
import { Card, CardContent, CardHeader, CardTitle } from "../container/card";
import { Text } from "./text";
import { TrendDown01, TrendUp01 } from "@untitledui/icons";
import { twMerge } from "tailwind-merge";

interface KPICardProps {
  label: string;
  value: string;
  valueClassName?: string;
  toneColor?: string;
  suffix?: string;
  description?: string;
  descriptionTrailing?: React.ReactNode;
  footer?: string;
  footerTrailing?: React.ReactNode;
  Icon?: React.JSXElementConstructor<{ className: string }>;
  iconColor?: string;
  bgColor?: string;
  onClick?: () => void;
}

export function KPICard({
  label,
  value,
  valueClassName,
  toneColor = "slate",
  suffix,
  description,
  descriptionTrailing,
  footer,
  footerTrailing,
  Icon,
  iconColor,
  bgColor,
  onClick,
}: KPICardProps) {
  return (
    <Card
      className={`cursor-pointer hover:bg-accent/50 transition-all duration-200`}
      onClick={onClick}
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle>
          {label}
        </CardTitle>

        {Icon && (
          <div
            className={cn(
              `bg-background text-${toneColor}-600 rounded-xl p-1.5`,
              iconColor
            )}
          >
            {" "}
            <Icon className={`h-5 w-5`} />{" "}
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="flex items-baseline gap-2">
          <Text className={twMerge("text-h4 font-bold", valueClassName)}>
            {value}
          </Text>
          {suffix && (
            <Text className="text-body font-normal text-muted-foreground">
              {suffix}
            </Text>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Text className="text-caption truncate">{description}</Text>
          {descriptionTrailing && descriptionTrailing !== "stable" && (
            <div className="flex items-center ml-auto">
              {descriptionTrailing === "up" ? (
                <TrendUp01 className="h-4 w-4 text-success" />
              ) : descriptionTrailing === "down" ? (
                <TrendDown01 className="h-4 w-4 text-destructive" />
              ) : null}
            </div>
          )}
        </div>
        <div className="flex justify-between items-center gap-2 pt-2">
          <Text className="text-body font-semibold  truncate">{footer}</Text>
          {footerTrailing}
        </div>
      </CardContent>
    </Card>
  );
}
